import { NgModule } from '@angular/core';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLayoutModule } from './layout/app.layout.module';
import { DialogService } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { AuthInterceptor } from './auth.interceptor';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { basePropertiesInterceptor } from './base.url.interceptor';
import { TextTransformPipe } from './demo/pipes/text-transform.pipe';
import { TranslocoRootModule } from './transloco-root.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NgxTranslateModule } from './translate.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http, '/assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        AppComponent,
        TextTransformPipe
    ],
    imports: [
        AppRoutingModule,
        AppLayoutModule,
        NgxTranslateModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (HttpLoaderFactory),
                deps: [HttpClient]
            }
        }),
    ],
    providers: [
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        DialogService,
        MessageService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        provideHttpClient(
            withInterceptors([basePropertiesInterceptor])
        )
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
